<template>
    <b-tabs card>
        <!-- Pipeline Results -->
        <b-tab title="Pipeline results" active>
            <div class="row border-bottom">
                <div class="col-12">
                    <div class="mb-2 float-right">
                        <div class="row">
                            <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                                <div class="btn-toolbar" role="toolbar">
                                    <div class="btn-group btn-group-justified" role="group">
                                        <div class="btn-group" role="group">
                                            <button id="results-refresh" class="btn btn-primary" data-original-title="Refresh" @click="refreshRunHistory()"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                            <b-tooltip target="results-refresh" triggers="hover">
                                                Refresh results list
                                            </b-tooltip>
                                        </div>
                                        <div class="btn-group" role="group">
                                            <button id="run" class="btn btn-primary" data-original-title="Run" @click.stop="OpenRunDialogue()"><i class="fas fa-play" aria-hidden="true"></i></button>
                                            <b-tooltip target="run" triggers="hover">
                                                Run pipelines
                                            </b-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <slidy-thing id="runPipelines" ref="runPipelines" width="500px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle">

                    <button type="button" class="btn btn-primary btn-lg btn-block mt-5" @click="runPipelinesForClaim">Run</button>
                </div>
            </slidy-thing>
            <data-list-pagination :dataCols="pipelineHistoryCols"
                                  :dataListItems="dataList"
                                  :tableClass="'table table-striped table-sm'"
                                  @dbl-click="handleHistoryItemDblClick"
                                  @pagination-input="handlePipelineRunHistoryPagenationInput " />
            <slidy-thing id="viewResults" ref="viewResults" width="617px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle2">
                    <div class="mb-3">
                        <i class="far fa-circle" style="color: darkorange"></i> Rule not run
                        <i class="far fa-check-circle" style="color: green"></i> Rule passed
                        <i class="far fa-times-circle" style="color: red"></i> Rule failed
                    </div>
                    <hr />
                    <div class="row mb-2" v-for="(rule, index) in selectedPipelineHistoryRules">
                        <div class="col">
                            <collapsible-card :initCollapsed="true">
                                <div slot="title">
                                    <div class="row">
                                        <div class="col-2">
                                            <i v-if="rule.StatusText == 'NOT_RUN'" class="far fa-circle fa-2x" style="color: darkorange"></i>
                                            <i v-if="rule.StatusText == 'PASSED'" class="far fa-check-circle fa-2x" style="color: green"></i>
                                            <i v-if="rule.StatusText == 'FAILED'" class="far fa-times-circle fa-2x" style="color: red"></i>
                                        </div>
                                        <div class="col">
                                            <h6>{{rule.RuleName.trim()}}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div slot="body">
                                    <hr />
                                    <json-viewer v-model="selectedPipelineHistoryRules[index]"
                                                 :viewMode="0" />
                                </div>
                            </collapsible-card>

                        </div>
                        <!--<div class="col-4">
                            <i v-if="rule.StatusText == 'NOT_RUN'" class="far fa-circle fa-3x" style="color: darkorange"></i>
                            <i v-if="rule.StatusText == 'PASSED'" class="far fa-check-circle fa-3x" style="color: green"></i>
                            <i v-if="rule.StatusText == 'FAILED'" class="far fa-times-circle fa-3x" style="color: red"></i>
                        </div>-->
                    </div>
                </div>
            </slidy-thing>
        </b-tab>
    </b-tabs>
</template>
<script>    
    import DataListPagination from '@/components/DataListPagination.vue'
    import JsonViewer from '@/components/jsonViewer.vue'
    import CollapsibleCard from '@/components/CollapsibleCard.vue'
    import SlidyThing from "@/components/SlidyThing.vue";

    import { selectedPipelineHistoryInputs } from '@/ui.config/inputs/selectedPipelineHistoryInputs'
    import { selectedPipelineHistoryCols } from '@/ui.config/cols/selectedPipelineHistoryCols'

    import { mapActions } from 'vuex'

    import { flatten } from '@/util/flatten'

    export default {
        components: {
            DataListPagination,
            'json-viewer': JsonViewer,
            'collapsible-card': CollapsibleCard,
            "slidy-thing": SlidyThing
        },
        data: () => {
            return {
                pipelineHistoryCols: [
                    //{
                    //    key: 'typeLabel',
                    //    display: 'Type'
                    //},
                    //{
                    //    key: 'makeLabel',
                    //    display: 'Make'
                    //},
                    //{
                    //    key: 'modelLabel',
                    //    display: 'Model'
                    //},
                    //{
                    //    key: 'imeiNo',
                    //    display: 'IMEI'
                    //},
                    //{
                    //    key: 'serialNo',
                    //    display: 'Serial'
                    //},
                    {
                        key: 'displayLabel',
                        display: 'Gadget'
                    },
                    {
                        key: 'pipelineLabel',
                        display: 'Pipeline'
                    },
                    {
                        key: 'runDateAsLocalTime',
                        display: 'Run Date'
                    },
                    {
                        key: 'runByName',
                        display: 'Run By'
                    },
                    {
                        key: 'passed',
                        display: 'Passed'
                    }
                ],
                selectedPipelineHistoryCols: selectedPipelineHistoryCols,
                selectedPipelineHistoryInputs: selectedPipelineHistoryInputs,
                
                selectedPipelineHistory: null,
                selectedPipelineHistoryRules: null,

                pipelineRunHistory: {
                    pageNumber: 1,
                    pageSize: 10
                }
            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            slidyThingContainerStyle() {
                return {
                    "overflow-y": "auto",
                    "max-height": "100%",
                    "max-width": '500px',
                    "min-width": '500px'
                }
            },
            slidyThingContainerStyle2() {
                return {
                    "overflow-y": "auto",
                    "max-height": "100%",
                    "max-width": '600px',
                    "min-width": '600px'
                }
            },
            dataList() {
                
                if (this.selectedClaim && this.selectedClaim.pipelineRunHistoryDetails) {
                    return this.selectedClaim.pipelineRunHistoryDetails.map(o => ({ ...o, displayLabel: `${o.makeLabel} - ${o.modelLabel} - ${o.serialNo || o.imeiNo}` }))
                } else {
                    return []
                }
                
            }
        },
        methods: {
            ...mapActions({
                'fetchPipelineRunHistoryClaim': 'fetchPipelineRunHistoryClaimV2',
                'runPipelines': 'validations/runPipelinesForClaim'
            }),
            handleHistoryItemDblClick(payload) {
                this.selectedPipelineHistory = payload
                let { result } = this.selectedPipelineHistory
                result = JSON.parse(result)
                this.selectedPipelineHistoryRules = []
                for (let i = 0; i < result.length; i++) {
                    this.selectedPipelineHistoryRules.push(flatten(result[i]))
                }
                if (this.$refs["viewResults"])
                    this.$refs["viewResults"].showPanel();
            },
            handlePipelineRunHistoryPagenationInput(payload) {
                this.pipelineRunHistory.pageNumber = payload
                this.selectedPipelineHistory = null
                this.selectedPipelineHistoryRules = []
                this.searchPipelineRunHistory()
            },
            searchPipelineRunHistory() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this.pipelineRunHistory

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    relatedId: claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchPipelineRunHistoryClaim(criteria)
            },
            OpenRunDialogue() {
                if (this.$refs["runPipelines"])
                    this.$refs["runPipelines"].showPanel();
            },
            async runPipelinesForClaim() {
                let { claimId } = this.selectedClaim

                let response = await this.runPipelines({ claimId })

                await this.refreshRunHistory()

                if (this.$refs["runPipelines"])
                    this.$refs["runPipelines"].hidePanel();
            },
            async refreshRunHistory() {
                let { claimId } = this.selectedClaim

                let response = await this.fetchPipelineRunHistoryClaim({ relatedId: claimId, orderBy: 'RunDate', sortDirection: 'DESC' })
            }
        }
    }
</script>